<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2024-01-15 09:44:55
-->
<template>
    <div class="add-danwei">
        <el-form ref="ruleForm"
                 :model="viewData"
                 :rules="rules"
                 label-width="100px">
            <el-form-item label="客服链接"
                          prop="kf_url">
                <el-input size="mini"
                          v-model="viewData.kf_url" />
            </el-form-item>
            <el-form-item label="头像"
                          prop="">
                <image-upload ref="imageUpload"
                              v-if="showUpload"
                              :tipInfo="`上传图片格式为'png'，大小不超过2M，建议尺寸'140*140',请自己处理好宽高比例`"
                              :image-list="imageDefaultList"
                              :maxNumber="1"
                              @updateImg="onUpdateImg($event)"></image-upload>
            </el-form-item>
        </el-form>
        <div class="fix-fotter">
            <el-button style="min-width: 117px;background: #1067E0;font-size: 16px;border-color: #1067E0;"
                       size="mini"
                       type="primary"
                       @click="tijiao('ruleForm')">提交</el-button>
        </div>
    </div>
</template>

<script>
  import ImageUpload from "@/components/Upload/image";
  import fetch from "@/api/tianzheng/guanjia";
  import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
  export default {
    data () {
      return {
        showUpload:false,
        showUpload1:false,
        thumbList: [],
        thumbList1: [],
        imageDefaultList: "",
        imageDefaultList1: "",
        viewData: {
          id: "",
          kf_url: "",
          avatar:''
        },
        rules: {
        },
      };
    },
    components: {
      Pagination,
      ImageUpload
    },
    created () { },
    methods: {
      onUpdateImg (val) {
        let thumbList = [];
        val.forEach((ele, idx) => {
          thumbList.push(ele.path);
        });
        this.thumbList = thumbList;
      },
      /**
       * @name: 初始化列表
       * @param {*} obj
       * @return {*}
       * @desc:
       */
      initFun (obj) {
        this.resetForm()
        let that = this
        this.viewData = {
          id: "",
          kf_url: "",
          avatar:''
        }
        this.showUpload = true
        if (obj.id) {
          // 编辑
          this.viewData.id = obj.id;
          fetch.detail({ id: obj.id }).then((res) => {
            if (res.code == 200) {
              that.viewData = res.result
              that.viewData.id = res.result.id;
              // that.viewData.status == res.result.status === true" ? 1 : 0;
              console.log(that.viewData.status)
              if (that.viewData.avatar && JSON.parse(that.viewData.avatar.length) > 0) {
                let imgList = [];
                let thumb_arr = JSON.parse(that.viewData.avatar);
                thumb_arr.forEach((ele, index) => {
                  let obj = {
                    name: ele,
                    path: ele,
                    url: that.$publicData.imgUrl + ele,
                  }
                  imgList.push(obj);
                })
                // 回显图
                that.imageDefaultList = JSON.stringify(imgList);
              };
            }
          });
        } else {
          // 新增
        }
      },
      /**
       * @name: 提交
       * @param {*} formName
       * @return {*}
       * @desc:
       */
      tijiao (formName) {
        let that = this
        this.viewData.avatar = this.thumbList;
        console.log(this.viewData)
        // if(this.viewData.zhang_pic.length<1){
        //     this.$message.warning("请上传电子收费章")
        //     return
        // }
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.viewData.id) {
              // 编辑
              fetch.edit(this.viewData).then(res => {
                if (res.code == 200) {
                  that.$message.success(res.message);
                  that.resetForm()
                  that.$emit('onUpdateDrawer', 1)
                } else {
                  that.$message.error(res.message);
                  that.resetForm()
                  that.$emit('onUpdateDrawer', -1)
                }
              })
            } else {
              // 新增
              fetch.create(this.viewData).then(res => {
                if (res.code == 200) {
                  that.$message.success(res.message);
                  that.resetForm()
                  that.$emit('onUpdateDrawer', 1)
                } else {
                  that.$message.error(res.message);
                  that.resetForm()
                  that.$emit('onUpdateDrawer', -1)
                }
              })
            }

          } else {
            this.$message.warning(this.$t('form.verifyMsg'))
          }
        })
      },
      /**
       * @name: 清空form
       * @return {*}
       * @desc:
       */
      resetForm () {
        this.thumbList = [];
        this.imageDefaultList = "";
        if (this.$refs.imageUpload) {
          this.$refs.imageUpload.clearFileList();
        }
        this.showUpload = false;
        this.$refs["ruleForm"].resetFields();
        this.viewData = {
          id: "",
          kf_url: "",
          avatar:''
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
